const styles = {
  addOnItemGridContainer: {
    display: { xs: "auto", md: "grid" },
    gridTemplateColumns: { md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" },
  },
};

export default styles;
